export const PUZZLE_TYPES = {
    CROSSWORD: {
        id: "CROSSWORD",
        name: "Crossword",
        description: "A puzzle consisting of a grid of squares and blanks into which words crossing vertically and horizontally are written according to clues.",
        icon: "✏️"
    },
    HIDDEN_MESSAGE: {
        id: "HIDDEN_MESSAGE", 
        name: "Hidden Message",
        description: "Answers or extracted letters reveal a secret phrase or clue.",
        icon: "💬"
    },
    WORD_SEARCH: {
        id: "WORD_SEARCH",
        name: "Word Search",
        description: "Find hidden words placed in a letter grid.",
        icon: "🔍"
    },
    SLIDING: {
        id: "SLIDING",
        name: "Sliding",
        description: "Sliding tile puzzles; language filter does not apply — schedules always use all languages.",
        icon: "🧩"
    },
    JIGSAW: {
        id: "JIGSAW",
        name: "Jigsaw",
        description: "Jigsaw puzzles from story images with configurable piece counts.",
        icon: "🧩"
    },
    WORD_WHEEL: {
        id: "WORD_WHEEL",
        name: "Word Wheel",
        description: "Find words using letters from a shared wheel on a crossword-style grid.",
        icon: "🎡"
    }
};

export const getPuzzleTypeById = (id) => {
    return PUZZLE_TYPES[id] || null;
};

export const getAllPuzzleTypes = () => {
    return Object.values(PUZZLE_TYPES);
};

